import { FC, Fragment, useMemo } from 'react'
import { LargeProductSuitCardsData } from '../types'
import { Stack } from '@dtx-company/design-system/src'
import { asText } from '@prismicio/client'
import { useScreenSizeBreakpoints } from '@app/common/src/hooks/useScreenSizeBreakpoints'
import LargeProductSuitCard from './LargeProductSuitCard'
import LargeProductSuitCardMobile from './LargeProductSuitCardMobile'
import PrismicText from '@app/prismic/src/components/PrismicText/PrismicText'

//sectionId is used for navigation
const LargeProductSuitCardsSection: FC<{
  data?: LargeProductSuitCardsData
  sectionId: string
}> = ({ data, sectionId }) => {
  const { isMobileOrTablet, isDesktop } = useScreenSizeBreakpoints()

  const Component = useMemo(() => {
    if (isMobileOrTablet) return LargeProductSuitCardMobile
    if (isDesktop) return LargeProductSuitCard
  }, [isDesktop, isMobileOrTablet])

  if (!data) return null

  return (
    <Stack
      id={sectionId}
      sx={{
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: '56px',
        my: {
          _: '32px',
          md: '56px',
          lg: '96px'
        }
      }}
    >
      {data?.items?.map((item, index) => (
        <Fragment key={asText(item.subheader)}>
          {index === 1 && (
            <PrismicText
              key={asText(data.primary?.subheader)}
              richTextField={data.primary?.subheader}
              variant="display/large"
              fontSize={{ _: '24px', md: '28px', lg: '32px' }}
              lineHeight={{ _: '30px', lg: '40px' }}
              textAlign="center"
              marginBottom="56px"
              px={{ _: '22px', md: '133px' }}
            />
          )}
          {Component && <Component data={item} />}
        </Fragment>
      ))}
    </Stack>
  )
}

export default LargeProductSuitCardsSection
